
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartDryingLineProposal as ObiChartDryingLineProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-drying-line-proposal.js';
 
 
 

 
 export const ObiChartDryingLineProposal = createComponent({
   react: React,
   tagName: 'obi-chart-drying-line-proposal',
   elementClass: ObiChartDryingLineProposalElement,
   events: {
     
   }
  });
 
 